import Carousel from "react-bootstrap/Carousel";
import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect, useMemo } from "react";
import "./vehicleDetail.css";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Loader from "../Loader";
import { SuccessNotify } from "../../constants/tostify";
import { FailedNotify } from "../../constants/tostify";
import { getAsset } from "../../helpers/helper";
import noImagePlaceholder from "../../assets/images/dummy/no_image_placeholder.png";
import BackArrow from "../../components/backArrow";
import { useSelector } from "react-redux";
import MainModal from "../ui/modal/modal";
import {
  useGetTransportVehicleByIdQuery,
  useDeleteTransportVehicleMutation,
} from "../../features/transport/transportVehicleApiSlice";

const resolveCarouselImages = (images) => {
  const list = Array.isArray(images)
    ? images.flat(Infinity).filter((item) => item && String(item).trim())
    : images && String(images).trim()
      ? [images]
      : [];

  if (!list.length) return [noImagePlaceholder];

  return list.map((item) => {
    const src = getAsset(item);
    if (!src || /\/assets\/?$/.test(src)) return noImagePlaceholder;
    return src;
  });
};

const Vehicaldetail = (props) => {
  const { id, shopid } = useParams();
  const isDummyId = id?.startsWith("dummy_");
  const [shows, setshows] = useState(0);
  const { name } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isDummyId) {
      FailedNotify("This is a placeholder slot. Add a real vehicle first.");
      navigate(`/transport-profile/${shopid}`, { replace: true });
    }
  }, [isDummyId, shopid, navigate]);

  const { data, isLoading: isFetching } = useGetTransportVehicleByIdQuery(id, {
    skip: !id || isDummyId,
  });
  const [deleteTransportVehicle, { isLoading: isDeleting }] =
    useDeleteTransportVehicleMutation();

  const singleCar = data?.data?.TransportVehicle;
  const isloading = isFetching || isDeleting;

  const carouselImages = useMemo(
    () => resolveCarouselImages(singleCar?.images),
    [singleCar?.images],
  );

  const handleClose = () => setshows(0);

  const handeldelete = async () => {
    if (isDummyId) {
      FailedNotify("Cannot delete a placeholder vehicle.");
      return;
    }

    try {
      const res = await deleteTransportVehicle(id).unwrap();
      if (res?.success) {
        setshows(0);
        SuccessNotify("Successfully Deleted");
        navigate(`/transport-profile/${shopid || singleCar?.shopid}`);
      }
    } catch {
      FailedNotify("Failed To Deleted");
    }
  };

  return (
    <>
      <Container>
        {shows === 1 && (
          <MainModal
            variant="deleteModal"
            shows={shows === 1}
            title="Profile"
            handleClose={handleClose}
            handledelete={handeldelete}
          />
        )}
        {isloading ? (
          <Loader heightsetting="screenHeight" />
        ) : (
          <div className={`${props.heightclass} noscroll`}>
            <Row className="screenHeight">
              <Col lg="10 mx-auto" className="p-4">
                <BackArrow />
                <Row>
                  <Col
                    sm={12}
                    md={9}
                    lg={12}
                    xl={12}
                    className="pe-0 ps-0 mt-2"
                  >
                    <div
                      className=" ps-3 pe-3 pb-2 rounded p-3"
                      style={{
                        boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)",
                      }}
                    >
                      <Carousel>
                        {carouselImages.map((src, index) => (
                          <Carousel.Item
                            className="img-items text-center"
                            key={index}
                          >
                            <img
                              className="car_img_w"
                              src={src}
                              alt={
                                src === noImagePlaceholder
                                  ? "No Image found"
                                  : "Vehicle"
                              }
                              crossOrigin={
                                src === noImagePlaceholder
                                  ? undefined
                                  : "anonymous"
                              }
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = noImagePlaceholder;
                                e.target.alt = "No Image found";
                              }}
                            />
                          </Carousel.Item>
                        ))}
                      </Carousel>
                    </div>
                  </Col>
                </Row>
                <Row
                  className="mt-3 rounded p-3"
                  style={{ boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)" }}
                >
                  <h3 className="font-bold">Vehicle Name and Model</h3>
                  <p className="font-grey">
                    {singleCar?.brandName} ({singleCar?.model})
                  </p>
                  <h5>Description</h5>
                  <p className="font-grey">{singleCar?.description}</p>
                  <Row>
                    <Col lg="3">
                      <p className="mb-0">
                        <b>Number Plate</b>
                      </p>
                      <p className="font-grey">{singleCar?.noPlate}</p>
                    </Col>
                    <Col lg="3">
                      <p className="mb-0">
                        <b>Vehicle Colour</b>
                      </p>
                      <p className="font-grey">{singleCar?.color}</p>
                    </Col>
                    <Col lg="6">
                      <h5>Contact us on</h5>
                      <p className="font-grey mb-0">{name?.email}</p>
                      <p className="font-grey">{singleCar?.contact}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" className="text-end">
                      {location.pathname === "/find-Transport" ? (
                        ""
                      ) : (
                        <Col lg="12">
                          <button
                            className="b-radius  text-danger border-0 ps-3 pe-3 pt-1 pb-1 bg-white btn-outline-1"
                            onClick={() =>
                              navigate(
                                `/transport-profile/${singleCar?.shopid}`,
                              )
                            }
                          >
                            Cancel
                          </button>
                          <button
                            className="b-radius bg-danger text-white border-0 ms-2 ps-3 pe-3 pt-1 pb-1"
                            onClick={() => setshows(1)}
                          >
                            <DeleteIcon className="icont_f" />
                            Delete
                          </button>
                          &nbsp;
                          <button
                            className="b-radius bg-primery text-white bg-btn-primary bg-app-btn border-0 ps-3 pe-3 pt-1 pb-1"
                            onClick={() =>
                              navigate("/transport-update-form/" + id)
                            }
                          >
                            <ModeEditOutlineIcon className="icont_f" />
                            Edit
                          </button>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </Row>
              </Col>
            </Row>
          </div>
        )}
      </Container>
    </>
  );
};
export default Vehicaldetail;
